import { isNullOrUndefined } from '@lmig/fluid-core';

import { fluidCurrencyLocales } from '../../model/forms/fluid-currency.locales';
import { Utils } from '../utils';

export const DEFAULT_LOCALE = 'en-US';

export interface CurrencyOptions {
  maximumFractionDigits: number;
  currency: string;
  style: 'currency';
}

export const currencyOptions = (
  currencySymbol,
  maximumFractionDigits?: number
): CurrencyOptions => ({
  maximumFractionDigits: isNullOrUndefined(maximumFractionDigits)
    ? 2
    : maximumFractionDigits,
  currency: currencySymbol,
  style: 'currency',
});

export const formatAsCurrency = (
  value: any,
  currencyLocale: string,
  currencySymbol: string,
  currencyOptions: CurrencyOptions,
  wholeOnly: boolean
) => {
  const locale =
    currencyLocale ||
    fluidCurrencyLocales[currencySymbol]?.locale ||
    DEFAULT_LOCALE;
  if (!currencyOptions.currency) {
    currencyOptions.currency = 'USD';
  }
  const formatter = wholeOnly
    ? new Intl.NumberFormat(locale, {
        ...currencyOptions,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      })
    : new Intl.NumberFormat(locale, currencyOptions);
  return Utils.isNullOrUndefined(value, true)
    ? ''
    : formatter.format(Number(value));
};

export const localStringToNumber = (s: string) =>
  Number(String(s).replace(/[^0-9.-]+/g, ''));

export const removeCurrencySymbol = (s: string) =>
  String(s).replace(/[^0-9.,-]+/g, '');
